/* eslint-disable */
import { getMaskedCardInformationFromToken } from '../components/NewOfferCyberSource/paymentUtil';
import { States_US } from './States';
import { deviceInfoPayload } from './deviceInformation';
import { formatWithHyphenZip, getMerchantId, getMerchantGroupId, getRefineZip } from './CommonLogic';
import { getMerchantIdByCountry, getMerchantGroupIdByCountry } from './mid';
export const paymentOfferPayload = (
    offerdata: any,
    billingInfo: any,
    contactInfo: any,
    token: any,
    refId?: any,
    trId?: any,
    ipAddress?: any,
    pinLeadDetails?: any,
    isCallMe?: boolean,
    pinDetails?: any,
    mailingData?: any,
    ucBillToDetails?: any,
    countriesData?: any,
) => {
    const pinData = pinDetails?.pin || ''
    const stateCode = (state: any) => {
        const stateObj = States_US?.filter((item: any) => item?.name === state);
        return stateObj && stateObj[0]?.code;
    };
    //const countryFullName: any = sessionStorage.getItem('countryFullName') || '';
    const getEfcVal = sessionStorage.getItem('effortCodeParam')
    const refinedEfcVal = getEfcVal === 'undefined' ? '' : getEfcVal;
    const effortCode = refinedEfcVal || offerdata?.loc;

    //const iso3Code = sessionStorage.getItem('iso3Code') || ''

    const getCountryByCode = (code: any) => {
        return countriesData?.find((c: any) => c?.iso2.toLowerCase() === code?.toLowerCase());
    };

    const zipCode = getRefineZip(billingInfo?.zipCode, billingInfo?.country)
    const countryDetails: any = getCountryByCode(billingInfo?.country)
    const iso3Code = countryDetails?.iso3 || ''
    const countryFullName = countryDetails?.name || ''
    const dialCode = pinLeadDetails?.dialCode || ''
    const savedPhone = pinLeadDetails?.phone ? `${dialCode}${pinLeadDetails?.phone}` : '';
    const offerPhone = contactInfo?.phone || '';
    const newPhone = offerPhone || savedPhone;
    //const billPhone = offerPhone || pinLeadDetails?.phone
    const email = contactInfo?.email || pinLeadDetails?.email
    const phNo = offerPhone || pinLeadDetails?.phone
    const billPhone = phNo || ''
    //const address = contactInfo?.addressLine1 || mailingData?.address
    const city = contactInfo?.city || mailingData?.city
    const prospectZipCode = contactInfo?.postalCode || mailingData?.zipCode
    //const prospectZipCode = formatWithHyphenZip(billingInfo?.zipCode)
    const state = contactInfo?.stateProvince || stateCode(mailingData?.state)


    const cardObj = getMaskedCardInformationFromToken(token);
    const roomTypes = offerdata?.roomTypes && offerdata?.roomTypes[0] || '';
    const offerProp = roomTypes?.property || ''
    const countryDesc = offerProp?.country || ''
    const currentDate = new Date();
    const formattedDate = currentDate?.toISOString() || '';
    const paymentId = `${contactInfo?.lastName}-${formattedDate}-${roomTypes?.roomTypeDescription}`;
    const depositAmt = (roomTypes?.depositAmount?.includes('$') && roomTypes?.depositAmount.split('$')) || '';
    const totalAmt = depositAmt && depositAmt[1];

    const deviceInfo = deviceInfoPayload();
    deviceInfo.ipAddress = ipAddress;

    const firstTwoChars = offerdata?.loc?.slice(0, 2) || '';
    const chargeSiteEnvVal = process.env.REACT_APP_CLIENT_OPB_CHARGE_SITE_ID_KEY || 'WCC';
    const chargeSite = `${firstTwoChars}*${chargeSiteEnvVal}`;
    //const zipCode = formatWithHyphenZip(billingInfo?.zipCode) || '';


    const defaultMerchantId = getMerchantId();
    const defaultMerchantGroupId = getMerchantGroupId();
    const offerCountry = roomTypes?.property?.country || '';
    const merchantId = getMerchantIdByCountry(offerCountry) || defaultMerchantId;
    const merchantGroupId = getMerchantGroupIdByCountry(offerCountry) || defaultMerchantGroupId;

    const payloadRequest: any = {
        payment: {
            tokenInformation: {
                transientTokenJwt: token,
                cardinalJwt: '',
            },
            clientReferenceInformation: {
                code: 'WEB_PBT',
                associate: false,
                customerId: contactInfo?.lastName,
                merchantGroupId: merchantGroupId,
                paymentId: paymentId, //currentTimestamp +roomTypes?.roomTypeDescription
                referenceId: refId,
                srcSystemName: 'WEB_PBT',
                transactionId: trId,
                storeCard: false,
            },
            orderInformation: {
                amountDetails: {
                    totalAmount: totalAmt,
                    currency: 'USD',
                },
                billTo: {
                    address1: billingInfo?.address || '',
                    address2: ucBillToDetails?.buildingNumber || '',
                    administrativeArea: billingInfo?.state || '',
                    country: billingInfo?.country || '',
                    email: email || '',
                    firstName: ucBillToDetails?.firstName || contactInfo?.firstName,
                    lastName: ucBillToDetails?.lastName || contactInfo?.lastName,
                    locality: billingInfo?.city,
                    postalCode: zipCode,
                    phoneNumber: billPhone || '',
                },
            },
            deviceInformation: deviceInfo,
            merchantDefinedInformation: [
                { key: '1', value: process.env.REACT_APP_CLIENT_OPB_CYBERSOURCE_OTM_INTL_ID_KEY || '' },
                { key: '2', value: offerdata?.loc },
                { key: '3', value: chargeSite },
                { key: '4', value: pinData },
            ],
        },
        confirm: {
            sourceName: process.env.REACT_APP_CLIENT_OPB_CYBERSOURCE_OTM_INTL_ID_KEY || '',
            isPbeoIntlFlag: true,
            effortCode: effortCode || offerdata?.loc,
            holdSessionId: '',
            pin: pinData,
            loc: offerdata?.loc,
            startDate: '',
            endDate: '',
            holidaySurcharge: '',
            holidayName: '',
            additionalNightCharge: '',
            totalCost: '',
            basePrice: '',
            retailPrice: '',
            additionalNights: 0,
            callCenterCode: contactInfo?.callCenterCode || '',
            tour: {
                offerId: offerdata?.offerCode,
                tourType: '',
                tourSiteCode: '',
                salesCenterCode: '',
                appointmentDate: '',
            },
            roomInformation: {
                accomodationCode: roomTypes?.accomodationCode,
                facilityPropertyID: '',
                miniHotelCode: '',
                propertyCode: '',
                rateCode: '',
                roomPoolCode: '',
                roomTypeCode: '',
                bookingRoomType: '',
                numberOfDays: roomTypes?.numberOfDays,
                numberOfNights: roomTypes?.numberOfNights,
                numberOfGuests: roomTypes?.sleepCapacity,
                numberOfAdults: '1',
                numberOfChildren: '0',
            },
            prospectInformation: {
                firstName: contactInfo?.firstName || '',
                lastName: contactInfo?.lastName || '',
                firstName2: '',
                lastName2: '',
                line1: billingInfo?.address || '',
                line2: ucBillToDetails?.buildingNumber || '',
                city: billingInfo?.city || '',
                stateProvince: billingInfo?.state || '',
                postalCode: zipCode || '',
                telephoneNumber: newPhone || '',
                emailAddress: email || '',
                doNotCall: isCallMe ? 'Y' : 'N',
                doNotMail: isCallMe ? 'Y' : 'N',
                countryCode: iso3Code || '',
                ISOCountryCode: iso3Code,
                countryDescription: countryFullName,

            },
            charge: {
                billingAddressLine1: billingInfo?.address,
                billingAddressLine2: ucBillToDetails?.buildingNumber || '',
                billingAddressLine3: '',
                billingEmailAddress: email || '',
                billingFirstName: ucBillToDetails?.firstName || contactInfo?.firstName,
                billingLastName: ucBillToDetails?.lastName || contactInfo?.lastName,
                billingPhoneNumber: billPhone || '',
                billingCity: billingInfo?.city || '',
                billingCountryCode: billingInfo?.country || '',
                billingStateProvinceCode: billingInfo?.state || '',
                billingZip: zipCode || '',
                cardCheck: cardObj?.maskedCardNumber,
                currencyCode: 'USD',
                expirationDate: cardObj?.expiration,
                //merchantID: process.env.REACT_APP_MERCHANTID_3DS,
                merchantID: merchantId,
                paymentMethodCode: cardObj?.cardType,
                preferredInvitationNumber: pinData,
                totalAmount: totalAmt,
                merchantGroupId: merchantGroupId,
            },
        },

    };
    return payloadRequest;
};
